import classes from "./SuccessIcon.module.scss";

const SuccessIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="74"
      height="74"
      viewBox="0 0 74 74"
      fill="none"
      className={classes.success}
    >
      <g clipPath="url(#clip0_3159_16983)">
        <path
          d="M37.0002 4.11133C30.4954 4.11133 24.1367 6.04023 18.7281 9.65411C13.3196 13.268 9.10414 18.4045 6.61486 24.4142C4.12558 30.4238 3.47427 37.0367 4.74329 43.4165C6.01232 49.7963 9.14468 55.6566 13.7443 60.2562C18.3439 64.8558 24.2041 67.9881 30.5839 69.2572C36.9637 70.5262 43.5766 69.8749 49.5863 67.3856C55.5959 64.8963 60.7325 60.6809 64.3463 55.2723C67.9602 49.8638 69.8891 43.505 69.8891 37.0002C69.8891 28.2775 66.4241 19.9121 60.2562 13.7443C54.0883 7.5764 45.7229 4.11133 37.0002 4.11133ZM37.0002 65.778C31.3085 65.778 25.7446 64.0902 21.0122 60.9281C16.2797 57.7659 12.5912 53.2715 10.413 48.013C8.23491 42.7545 7.66501 36.9683 8.77541 31.386C9.88581 25.8036 12.6266 20.6759 16.6513 16.6513C20.6759 12.6266 25.8036 9.88579 31.386 8.7754C36.9683 7.665 42.7546 8.2349 48.013 10.413C53.2715 12.5911 57.7659 16.2797 60.9281 21.0121C64.0902 25.7446 65.778 31.3085 65.778 37.0002C65.778 44.6326 62.7461 51.9523 57.3492 57.3492C51.9523 62.7461 44.6326 65.778 37.0002 65.778Z"
          fill="#1FB80F"
        />
        <path
          d="M57.5552 24.8722C57.1701 24.4893 56.6491 24.2744 56.106 24.2744C55.563 24.2744 55.042 24.4893 54.6569 24.8722L31.8402 47.586L19.5069 35.2527C19.1307 34.8466 18.6086 34.6065 18.0554 34.5853C17.5022 34.5641 16.9633 34.7635 16.5572 35.1397C16.151 35.5158 15.9109 36.0379 15.8897 36.5911C15.8685 37.1443 16.0679 37.6832 16.4441 38.0894L31.8402 53.4444L57.5552 27.791C57.7479 27.6 57.9008 27.3726 58.0051 27.1221C58.1095 26.8716 58.1632 26.603 58.1632 26.3316C58.1632 26.0602 58.1095 25.7916 58.0051 25.5411C57.9008 25.2906 57.7479 25.0632 57.5552 24.8722Z"
          fill="#1FB80F"
        />
      </g>
      <defs>
        <clipPath id="clip0_3159_16983">
          <rect width="74" height="74" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default SuccessIcon;
